import templateUrl from './animal-information.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    animalTypes: '<',
    sexes: '<',
    locked: '<'
  },
  controller: class AnimalInformationComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-information/animal-information.component.js